import { connect } from "react-redux";
import BenchmarkAnalysis from "./BenchmarkAnalysis";
import { handleChangeBenchmarkFilter } from "../../../../redux/actions";


const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkAnalysis);
